<template>
  <v-app-bar v-bind="appBarTopProps">
    <v-btn width="40" min-width="40"
           height="40"
           class="mr-5"
           plain
    >
      <img :src="require('@/assets/images/ico-prev.png')" alt="뒤로 가기"
           @click="$router.back()"
      >
    </v-btn>

    <v-toolbar-title>
      <img src="/images/common/h1-olens.png"
           alt="오렌즈"
           role="button"
           @click="$router.push({name: 'main'})"
      >
    </v-toolbar-title>

    <v-spacer />

    <v-btn icon width="40" height="72"
           @click="$router.push({ name: 'search' })"
    >
      <v-img src="@/assets/images/search.png" width="40" height="40" />
    </v-btn>

    <v-btn icon width="40" height="40" class="ml-10 cart-btn"
           @click="$router.push({ name: 'cart' })"
    >
      <v-img src="@/assets/images/cart.png" width="40" height="40" />
      <div class="count">
        <div>{{count | numberFormat}}</div>
      </div>
    </v-btn>
  </v-app-bar>
</template>

<script>

import { sync } from 'vuex-pathify';
import numberFormat from "@/assets/filters/numberFormat";
import store from "@/store";

export default {
  name: 'SubTopBar',
  props: {
    appBarTopProps: { type: Object, default: () => ({}) },
  },
  filters: {numberFormat},
  data: () => ({
  }),
  computed: {
    custId: sync('app/custId'),
    userId: sync('app/userId'),
    userNm: sync('app/userNm'),
    count: sync('product/cartCount'),
  },
  mounted() {
    if (!!this.userNm && !!this.userId && !!this.custId) {
      this.fetchCartCount();
    }
  },
  methods: {
    fetchCartCount() {
      this.$axios.get('/v2/carts/count')
          .then(response => {
            if (response.data.code === 'SUCCESS') {
              store.set('product/cartCount', response.data.data);
            }
          });
    }
  },
};
</script>
<style scoped lang="scss">
.cart-btn {
  position: relative;
  .count {
    position: absolute;
    right: -14px;
    top: -8px;
    text-align: center;
    background-color: #FF67A9;
    min-width: 28px;
    height: 28px;
    padding: 6px 3px;
    border-radius: 100%;
    @include font(16px, #fff, 700, 1px, 1);
  }
}
</style>
